import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Person from './view/person';

const PersonRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Person />} />
  </ErrorBoundaryRoutes>
);

export default PersonRoutes;
